import Naira from "react-naira";
import React, { useState, useEffect } from "react";
import "react-dropdown/style.css";
import useTable from "../../../utilities/useTable";
import Controls from "../../../controls/Controls";
import Popup from "../../../utilities/Popup";
import { connect } from "react-redux";
import "./sales.styles.scss";
import NewSalesForm from "./NewSalesForm";
import { AddItem } from "../../../../redux-store/reducers/cart-reducer/cart.action";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import { Toolbar } from "@material-ui/core";

function Sales({ AddItem, categories, LoadProducts, products, locations }) {
  var updatedCategories = [...categories];

  const [quantity, setQuantity] = useState(0);
  const [location] = useState(1);
  const [category] = useState(1);
  const [item, setItem] = useState("");
  const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
    var payload = {
      location: location,
      category: category,
    };
    LoadProducts(payload);

    return () => {};
  }, []);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  function setLocationV(e) {
    localStorage.setItem("loc_1x", e.target.value);
    if (
      localStorage.getItem("loc_1x") > 0 &&
      localStorage.getItem("cat_1x") > 0
    ) {
      var payload = {
        location: localStorage.getItem("loc_1x"),
        category: localStorage.getItem("cat_1x"),
      };
      LoadProducts(payload);
    }
  }

  function setCategoryV(e) {
    localStorage.setItem("cat_1x", e.target.value);
    if (
      localStorage.getItem("loc_1x") > 0 &&
      localStorage.getItem("cat_1x") > 0
    ) {
      var payload = {
        location: localStorage.getItem("loc_1x"),
        category: localStorage.getItem("cat_1x"),
      };
      LoadProducts(payload);
    }
  }

  function setQuantityValue(e) {
    setQuantity(e.target.value);
    setItem(e.target.name.split("%")[1]);
  }

  function AddToCart() {
    if (!quantity) {
      alert("Insert Quantity");
    } else {
      AddItem(JSON.parse(item), quantity, products);
    }
  }

  const { TblPagination, recordsAfterPagingAndSorting } = useTable(
    products,
    null,
    filterFn
  );

  return (
    <>
      <div
        className="sales-main container"
        style={{ paddingTop: "40px", height: "100vh" }}
      >
        <div className="filter">
          <h4 className="text-dark">
            {" "}
            <strong>Sales Item </strong>
          </h4>
          <TblPagination />
          <div className="d-flex w-50">
            <div style={{ marginRight: "1rem", width: "50%" }}>
              <Controls.Select
                name="categoryId"
                label="Categories"
                placeholder="Categories"
                onChange={setCategoryV}
                options={updatedCategories}
              />
            </div>

            <div style={{ width: "50%" }}>
              <Controls.Select
                name="locationId"
                label="Locations"
                placeholder="Locations"
                onChange={setLocationV}
                options={locations}
              />
            </div>
          </div>
        </div>

        <div className="text-center mt-3">
          <Toolbar>
            <Controls.Button
              className="w-25 text-center"
              text="New Sales"
              variant="contained"
              onClick={() => setOpenPopup(true)}
              startIcon={<ShoppingCart />}
            />
          </Toolbar>
        </div>

        {products.length > 0 ? (
          <div className="row d-flex pt-3">
            {recordsAfterPagingAndSorting().map((shop) => {
              return (
                <>
                  <div className="col-sm-12 col-md-6 col-lg-3 ftco-animate">
                    <div
                      className="product p-3"
                      style={{
                        border: "2px solid #3f51b5",
                        borderRadius: "10px",
                      }}
                    >
                      <a
                        href="#"
                        className="img-prod pb-2"
                        style={{ borderBottom: "2px solid #3f51b5" }}
                      >
                        {shop.imageId.length == 1 ? (
                          <img
                            className="img-fluid h-40 object-cover w-full"
                            src="/product-image.png"
                          />
                        ) : (
                          <img className="img-fluid w-full object-cover" src={shop.imageId} />
                        )}
                        <div className="overlay" />
                      </a>
                      <div className="text py-3 px-3">
                        {shop.productName}
                        <div className="pricing">
                          <div className="row">
                            <div className="col">
                              <p className="price">
                                <span className="font-black">
                                  <Naira>{shop.salesPrice}</Naira>
                                </span>
                              </p>
                            </div>
                            <div className="col float-right">
                              <p className="price">
                                <span>
                                  <small></small>
                                </span>
                              </p>
                              <br />
                            </div>
                            <div>Qty left: {shop.quantityy}</div>
                          </div>
                          <div className="pt-3">
                            <input
                              type="number"
                              className="form-control w-100"
                              name={`quantity%${JSON.stringify(shop)}`}
                              onChange={setQuantityValue}
                              placeholder="Enter Quantity"
                            />
                            <Controls.Button
                              className="text-center my-3 w-100"
                              text="Add to Cart"
                              startIcon={<ShoppingCart />}
                              onClick={() => AddToCart()}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        ) : (
          <div>
            <h4 className="text-center mt-5">
              <strong> No Products Available </strong>
            </h4>
          </div>
        )}

        <Popup
          title="New Sales Form"
          setOpenPopup={setOpenPopup}
          openPopup={openPopup}
        >
          <NewSalesForm setOpenPopup={setOpenPopup} />
        </Popup>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  console.log(state);
  return {
    categories: state.productReducer.categories,
    locations: state.locationReducer.locationDrop,
    products: state.salesReducer.products,
  };
}

const mapToDispatchToProps = (dispatch) => ({
  LoadProducts(payload) {
    dispatch({ type: "LOAD_SALES_PRODUCT_LIST", payload });
  },

  AddItem: (item, qty, products) => {
    if (Number(item.quantityy.replace(/,/g, "")) > 0) {
      console.log(item);
      return dispatch(AddItem(item, parseFloat(qty), products)); //setting the values,
    } else {
      alert("Item no longer exist in store");
    }
  },
});

export default connect(mapStateToProps, mapToDispatchToProps)(Sales);
